<template>
    <div class="acomodar">

        <InsertarEmpXcc/>
        
    </div>
</template>

<script>
import InsertarEmpXcc from '@/components/ModSeleccion/Acceso/RegistrarProyectoEmpresa.vue';
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global
export default {
    name: 'SolimanologInsertarEmCc',
    components:{
        InsertarEmpXcc
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

